import { Routes } from '@angular/router';
import { RoleBasedRouting } from './components/main/roleBasedRouting.component';
import { isUserAuthentcatedRoutesGuard } from './services/isUserAuthentcated-routes-guard.service';
import { ExternalRoutesGuard } from './services/external-routes-guard.service';
import { Teacher } from './../teacher/components/main/teacher.component';

export const ROUTES: Routes = [
    {
      path: '', component: RoleBasedRouting, canActivate: [isUserAuthentcatedRoutesGuard]
    },
    {
      path: 'teacher', component: Teacher
    },
    {
      path: 'externalRedirect' , canActivate: [ExternalRoutesGuard],
      component: RoleBasedRouting,
    },
    {
      path: '**', redirectTo: '', pathMatch: 'full'
    }
];
